import { INPUT_PROTECTION_TYPE } from "../sim-constants";

//Contains custom data for our input protection diodes.  This data replaces the diode capacitance data in basic-input-protection and adds configuration information.
export let data = {
    "map": {
        "CG0603MLA": "CG0603MLA", 
        "CDSOD323" : "CDSOD323",       
        "GSD2004S" : "GSD2004S",
        "CG0603MLA-26KE" : "CG0603MLA-26KE",
        "CDSOD323-T36SC" : "CDSOD323-T36SC",
        "GSD2004S-E3-08" : "GSD2004S-E3-08",
        "CMSD6001S" : "CMSD6001S",
        "1SS362FV,L3F" : "1SS362FV,L3F",
    },

    "partData": {
        "CG0603MLA": {
            diodeCapacitance: 100e-12,
            diodeType: INPUT_PROTECTION_TYPE.VARISTOR,
            reverseVoltage: 24,
            requiredPDBParameters: [],
            diodeLeakage: 1e-6,
            referenceTemp: 85, //Assuming 85C due to large leakage. 1/18/24: RJ
        },
        "CDSOD323" : {
            diodeCapacitance: 35e-12,
            diodeType: INPUT_PROTECTION_TYPE.BACK_TO_BACK,
            reverseVoltage: 36,
            requiredPDBParameters: [],
            diodeLeakage: 1e-6,
            referenceTemp: 25, //Added 1/18/24: RJ (Bourns Datasheet)
        },
        "GSD2004S" : {
            diodeCapacitance: 5e-12,
            diodeType : INPUT_PROTECTION_TYPE.STACKED,
            reverseVoltage: 240,
            requiredPDBParameters: [],
            diodeLeakage: 100e-9, //240V, 25°C ? RJ: 1/18/24
            referenceTemp: 25, //Added 1/18/24: RJ (Vishay Datasheet)
        },
        "CG0603MLA-26KE" : {
            diodeCapacitance: 100e-12,
            diodeType : INPUT_PROTECTION_TYPE.VARISTOR,
            reverseVoltage: 26,
            requiredPDBParameters: [], 
            diodeLeakage: 1e-6,
            referenceTemp: 85, //Assuming 85C due to large leakage. 1/18/24: RJ
        },
        "CDSOD323-T36SC" : {
            diodeCapacitance: 35e-12,
            diodeType: INPUT_PROTECTION_TYPE.BACK_TO_BACK,
            reverseVoltage: 36,
            requiredPDBParameters: [], 
            diodeLeakage: 1e-6, //Maximum Leakage Current @VWM, 25C?? 1/18/24: RJ
            referenceTemp: 25, //
        },
        "GSD2004S-E3-08" : {
            diodeCapacitance: 5e-12,
            diodeType : INPUT_PROTECTION_TYPE.STACKED,
            reverseVoltage: 240,
            requiredPDBParameters: [],
            diodeLeakage: 100e-9, //240V, 25°C ? RJ: 1/18/24
            referenceTemp: 25, //Added 1/18/24: RJ
        },
        "CMSD6001S" : {
            diodeCapacitance: 2e-12,
            diodeType : INPUT_PROTECTION_TYPE.STACKED,
            reverseVoltage: 75,
            requiredPDBParameters: [],
            diodeLeakage: 500e-12, //75V, 25°C ? RJ: 1/18/24
            referenceTemp: 25, //Added 1/18/24: RJ
        },
        "1SS362FV,L3F" : {
            diodeCapacitance: 0.9e-12,
            diodeType : INPUT_PROTECTION_TYPE.STACKED,
            reverseVoltage: 80,
            requiredPDBParameters: [],
            diodeLeakage: 500e-9, //50V, 100°C ? RJ: 1/18/24
            referenceTemp: 100, //Added 1/18/24: RJ
        },
    }
}